export function initHeader() {
    triggerBurger();
    toggleSubmenuMobile();
    hoverSubMenu();
    searchEventHandlers();
}

function searchEventHandlers() {
    const className = 'search-active';
    $(document).on("click", "[data-search-trigger]", function (e) {
        e.preventDefault();
        $('body').toggleClass(className);
    });

    //[data-close-search]
    $(document).on("click", "[data-close-search]", function (e) {
        e.preventDefault();
        $('body').removeClass(className);
    });
}

function triggerBurger() {
    let menu_active = false;
    $(document).on("click", ".burger", function (e) {
        e.preventDefault();
        menu_active = toggleBurger(menu_active);
    });

    $(document).on('click', '.menu-overlay', function () {
        $('body').removeClass('menu-active search-active');
    });
}

function toggleSubmenuMobile() {
    $("ul.menu > li.menu-item-has-children, ul.menu").each(function () {
        if (!$(this).find('.toggle-children').length) {
            $("> a", this).append('<span class="toggle-children"></span>');
        }
    });

    $(document).on("click", "span.toggle-children", function (e) {
        e.preventDefault();
        if ($(this).hasClass('toggle-active')) {
            $(this).removeClass("toggle-active");
            $(this).parent("a").siblings("ul.sub-menu").slideUp();
        } else {
            $(this).addClass("toggle-active");
            $(this).parent("a").siblings("ul.sub-menu").slideDown();
        }
    });
}

function hoverSubMenu() {
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        let li_item_sub_menu = "header ul.menu > li.menu-item-has-children";
        $(li_item_sub_menu).hover(
            function () {
                $('body').addClass('menu-hovered');
            },
            function () {
                $('body').removeClass('menu-hovered');
            }
        );
    }
}

// Burger function
function toggleBurger(menu_active) {
    if (menu_active === false) {
        $("body").addClass("menu-active");
        menu_active = true;
    } else {
        $("body").removeClass("menu-active");
        menu_active = false;
    }

    return menu_active;
}